
angular.module('app.controllers.residential', []).controller('ResidentialController', ['$rootScope','$scope','$log', '$timeout', '$animate', function ($rootScope, $scope, $log, $timeout, $animate) {

  'use strict';

  $log.debug('ResidentialController()');


}]);

